import React, { createContext } from "react";

// Create Context
const InventoryContext = createContext<any>(null); 

export default InventoryContext;
